import React from 'react';
import { ComponentProps, IconType } from './Icon.types';
import IconStyled from './Icon.styled';

const map: Map<ComponentProps['type'], (color: string) => JSX.Element> = new Map<
  IconType,
  (color: string) => JSX.Element
>([
  [
    'time',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11.78 7H11.72C11.32 7 11 7.32 11 7.72V12.44C11 12.79 11.18 13.12 11.49 13.3L15.64 15.79C15.98 15.99 16.42 15.89 16.62 15.55C16.83 15.21 16.72 14.76 16.37 14.56L12.5 12.26V7.72C12.5 7.32 12.18 7 11.78 7Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'error',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 13C11.45 13 11 12.55 11 12V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V12C13 12.55 12.55 13 12 13ZM13 17H11V15H13V17Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'accept',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 16.2L5.5 12.7C5.11 12.31 4.49 12.31 4.1 12.7C3.71 13.09 3.71 13.71 4.1 14.1L8.29 18.29C8.68 18.68 9.31 18.68 9.7 18.29L20.3 7.70001C20.69 7.31001 20.69 6.69001 20.3 6.30001C19.91 5.91001 19.29 5.91001 18.9 6.30001L9 16.2Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowRight',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 13H16.17L11.29 17.88C10.9 18.27 10.9 18.91 11.29 19.3C11.68 19.69 12.31 19.69 12.7 19.3L19.29 12.71C19.68 12.32 19.68 11.69 19.29 11.3L12.71 4.7C12.32 4.31 11.69 4.31 11.3 4.7C10.91 5.09 10.91 5.72 11.3 6.11L16.17 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'lock',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM9 8V6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'link',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 7H14C13.45 7 13 7.45 13 8C13 8.55 13.45 9 14 9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H14C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM8 12C8 12.55 8.45 13 9 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11H9C8.45 11 8 11.45 8 12ZM10 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H10C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H10C10.55 17 11 16.55 11 16C11 15.45 10.55 15 10 15Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'attachMoney',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.66 9.81 6.9 11.5 6.9C12.92 6.9 13.63 7.44 13.89 8.3C14.01 8.7 14.34 9 14.76 9H15.06C15.72 9 16.19 8.35 15.96 7.73C15.54 6.55 14.56 5.57 13 5.19V4.5C13 3.67 12.33 3 11.5 3C10.67 3 10 3.67 10 4.5V5.16C8.06 5.58 6.5 6.84 6.5 8.77C6.5 11.08 8.41 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.85 17.1 9 16.51 8.67 15.67C8.52 15.28 8.18 15 7.77 15H7.49C6.82 15 6.35 15.68 6.6 16.3C7.17 17.69 8.5 18.51 10 18.83V19.5C10 20.33 10.67 21 11.5 21C12.33 21 13 20.33 13 19.5V18.85C14.95 18.48 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.49 11.8 10.9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'warning',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.73 21H21.26C22.03 21 22.51 20.17 22.13 19.5L12.86 3.5C12.47 2.83 11.51 2.83 11.13 3.5L1.86 19.5C1.48 20.17 1.96 21 2.73 21ZM13 18H11V16H13V18ZM12 14C11.45 14 11 13.55 11 13V11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11V13C13 13.55 12.55 14 12 14Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'checkCircle',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9.29 16.29L5.7 12.7C5.31 12.31 5.31 11.68 5.7 11.29C6.09 10.9 6.72 10.9 7.11 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.7 16.29C10.32 16.68 9.68 16.68 9.29 16.29Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'resize',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 17H15V15H17V17ZM17 13H15V11H17V13ZM13 17H11V15H13V17ZM13 13H11V11H13V13ZM9 17H7V15H9V17ZM17 9H15V7H17V9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'pound',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1997 6.31663C13.612 6.07575 12.9615 6.03448 12.348 6.19917C11.7346 6.36385 11.1922 6.72537 10.8041 7.22821C10.4167 7.73024 10.2045 8.34541 10.2 8.9795V11.8759H14C14.6075 11.8759 15.1 12.3684 15.1 12.9759C15.1 13.5834 14.6075 14.0759 14 14.0759H10.2V16.4759C10.2 16.5169 10.1977 16.5579 10.1931 16.5987C10.1761 16.7501 10.1507 16.8999 10.1173 17.0475C10.9125 17.0447 11.7042 17.1756 12.4589 17.4361C12.4927 17.4478 12.5259 17.461 12.5583 17.4759C13.1989 17.7695 13.8953 17.9215 14.6 17.9215C15.3047 17.9215 16.0011 17.7695 16.6417 17.4759C17.1939 17.2228 17.8468 17.4653 18.1 18.0176C18.3531 18.5698 18.1106 19.2227 17.5583 19.4759C16.6301 19.9013 15.6211 20.1215 14.6 20.1215C13.5985 20.1215 12.6085 19.9096 11.695 19.5C11.0388 19.2808 10.3434 19.2029 9.65458 19.2718C9.19687 19.3176 8.74913 19.4274 8.32422 19.5972C8.05474 19.7691 7.76479 19.9098 7.45978 20.0154C6.92558 20.2003 6.33819 19.9502 6.10127 19.4369C5.86434 18.9237 6.05502 18.3144 6.54226 18.0278C6.77607 17.8902 7.01701 17.7665 7.26385 17.6571C7.38935 17.5623 7.5032 17.4518 7.60241 17.3278C7.81518 17.0618 7.95234 16.7438 7.99999 16.4073V14.0759H6.99999C6.39248 14.0759 5.89999 13.5834 5.89999 12.9759C5.89999 12.3684 6.39248 11.8759 6.99999 11.8759H7.99999V8.96926C8.00672 7.85227 8.38 6.76838 9.06246 5.88409C9.74491 4.9998 10.6988 4.36401 11.7776 4.0744C12.8564 3.78479 14.0005 3.85736 15.0341 4.28098C16.0676 4.70459 16.9335 5.45582 17.4988 6.41926C17.8062 6.94325 17.6306 7.61724 17.1066 7.92466C16.5826 8.23208 15.9086 8.05651 15.6012 7.53252C15.2798 6.98468 14.7874 6.55751 14.1997 6.31663Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'upload',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4H6C5.45 4 5 4.45 5 5ZM7.41 14H9V19C9 19.55 9.45 20 10 20H14C14.55 20 15 19.55 15 19V14H16.59C17.48 14 17.93 12.92 17.3 12.29L12.71 7.7C12.32 7.31 11.69 7.31 11.3 7.7L6.71 12.29C6.08 12.92 6.52 14 7.41 14Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'download',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 19C19 18.45 18.55 18 18 18L6 18C5.45 18 5 18.45 5 19C5 19.55 5.45 20 6 20L18 20C18.55 20 19 19.55 19 19ZM16.59 10L15 10L15 5C15 4.45 14.55 4 14 4L10 4C9.45 4 9 4.45 9 5L9 10L7.41 10C6.52 10 6.07 11.08 6.7 11.71L11.29 16.3C11.68 16.69 12.31 16.69 12.7 16.3L17.29 11.71C17.92 11.08 17.48 10 16.59 10Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'sort',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 7.60401L15.6039 9L11.4902 4.79087L7.39068 8.96962L6 7.50691L11.49 2L17 7.60401Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 15.396L7.39614 14L11.5098 18.2091L15.6093 14.0304L17 15.4931L11.51 21L6 15.396Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'calendar',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 13H13C12.45 13 12 13.45 12 14V17C12 17.55 12.45 18 13 18H16C16.55 18 17 17.55 17 17V14C17 13.45 16.55 13 16 13ZM16 3V4H8V3C8 2.45 7.55 2 7 2C6.45 2 6 2.45 6 3V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V3C18 2.45 17.55 2 17 2C16.45 2 16 2.45 16 3ZM18 20H6C5.45 20 5 19.55 5 19V9H19V19C19 19.55 18.55 20 18 20Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'iconLeft',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.705 16.875L11.125 12.295L15.705 7.705L14.295 6.295L8.295 12.295L14.295 18.295L15.705 16.875Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'iconRight',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.295 16.285L12.875 11.705L8.295 7.115L9.705 5.705L15.705 11.705L9.705 17.705L8.295 16.285Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'iconDown',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 8.58L12 13.17L16.59 8.58L18 10L12 16L6 10L7.41 8.58Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'iconUp',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 16.42L12 11.83L16.59 16.42L18 15L12 9L6 15L7.41 16.42Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'bullet',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="4" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'arrowDropDown',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.71001 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.41001C8.52001 10 8.08001 11.08 8.71001 11.71Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowDropUp',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.2975 12.8825L12.7075 10.2925C12.3175 9.9025 11.6875 9.9025 11.2975 10.2925L8.70752 12.8825C8.07752 13.5125 8.52752 14.5925 9.41752 14.5925L14.5975 14.5925C15.4875 14.5925 15.9275 13.5125 15.2975 12.8825Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowDropRight',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.71 15.29L14.3 12.7C14.3927 12.6075 14.4663 12.4976 14.5164 12.3766C14.5666 12.2557 14.5924 12.126 14.5924 11.995C14.5924 11.864 14.5666 11.7344 14.5164 11.6134C14.4663 11.4924 14.3927 11.3825 14.3 11.29L11.71 8.7C11.08 8.08 10 8.52 10 9.41V14.58C10 15.48 11.08 15.92 11.71 15.29Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowDropLeft',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.29 8.71001L9.70001 11.3C9.6073 11.3925 9.53376 11.5024 9.48357 11.6234C9.43339 11.7444 9.40756 11.874 9.40756 12.005C9.40756 12.136 9.43339 12.2657 9.48357 12.3866C9.53376 12.5076 9.6073 12.6175 9.70001 12.71L12.29 15.3C12.92 15.93 14 15.48 14 14.59V9.41001C14 8.52001 12.92 8.08001 12.29 8.71001Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'phone',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.2652 15.5 20.5196 15.6054 20.7071 15.7929C20.8946 15.9804 21 16.2348 21 16.5V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21C15.4913 21 11.1673 19.2089 7.97918 16.0208C4.79107 12.8327 3 8.50868 3 4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H7.5C7.76522 3 8.01957 3.10536 8.20711 3.29289C8.39464 3.48043 8.5 3.73478 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'help',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.67 12.68 13.31 13.14 13.13 13.86C13.05 14.18 13 14.54 13 15H11V14.5C11 14.04 11.08 13.6 11.22 13.19C11.42 12.61 11.75 12.09 12.17 11.67L13.41 10.41C13.87 9.97 14.09 9.31 13.96 8.61C13.83 7.89 13.27 7.28 12.57 7.08C11.46 6.77 10.43 7.4 10.1 8.35C9.98 8.72 9.67 9 9.28 9H8.98C8.4 9 8 8.44 8.16 7.88C8.59 6.41 9.84 5.29 11.39 5.05C12.91 4.81 14.36 5.6 15.26 6.85C16.44 8.48 16.09 10.23 15.07 11.25Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'close',
    (color: string) => (
      <IconStyled width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.3.71a.996.996 0 00-1.41 0L7 5.59 2.11.7A.997.997 0 10.7 2.11L5.59 7 .7 11.89a.997.997 0 001.41 1.41L7 8.41l4.89 4.89a.997.997 0 001.41-1.41L8.41 7l4.89-4.89c.38-.38.38-1.02 0-1.4z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'account',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'home',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 19V14H14V19C14 19.55 14.45 20 15 20H18C18.55 20 19 19.55 19 19V12H20.7C21.16 12 21.38 11.43 21.03 11.13L12.67 3.6C12.29 3.26 11.71 3.26 11.33 3.6L2.97 11.13C2.63 11.43 2.84 12 3.3 12H5V19C5 19.55 5.45 20 6 20H9C9.55 20 10 19.55 10 19Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'exit',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.79 16.29C11.18 16.68 11.81 16.68 12.2 16.29L15.79 12.7C16.18 12.31 16.18 11.68 15.79 11.29L12.2 7.7C11.81 7.31 11.18 7.31 10.79 7.7C10.4 8.09 10.4 8.72 10.79 9.11L12.67 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H12.67L10.79 14.88C10.4 15.27 10.41 15.91 10.79 16.29ZM19 3H5C3.89 3 3 3.9 3 5V8C3 8.55 3.45 9 4 9C4.55 9 5 8.55 5 8V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V16C5 15.45 4.55 15 4 15C3.45 15 3 15.45 3 16V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'declarations',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM9 17H6C5.45 17 5 16.55 5 16C5 15.45 5.45 15 6 15H9C9.55 15 10 15.45 10 16C10 16.55 9.55 17 9 17ZM9 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H9C9.55 11 10 11.45 10 12C10 12.55 9.55 13 9 13ZM9 9H6C5.45 9 5 8.55 5 8C5 7.45 5.45 7 6 7H9C9.55 7 10 7.45 10 8C10 8.55 9.55 9 9 9ZM18.7 11.12L15.53 14.29C15.14 14.68 14.5 14.68 14.11 14.29L12.7 12.87C12.31 12.48 12.31 11.85 12.7 11.46C13.09 11.07 13.72 11.07 14.11 11.46L14.82 12.17L17.29 9.7C17.68 9.31 18.31 9.31 18.7 9.7L18.71 9.71C19.09 10.1 19.09 10.74 18.7 11.12Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'productSelection',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 5V19H5V5H19ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'more',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'loan',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 6C12 5.45 11.55 5 11 5H5.82L6.48 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 0.79L5.38 0L0.44 4.94C0.17 5.21 0 5.59 0 6V12.5C0 13.33 0.67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6ZM22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.52 22.18L17.5 22.42C17.5 22.73 17.63 23.01 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'applicants',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'income',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'expenditure',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 11.5V15.5C4 16.33 4.67 17 5.5 17C6.33 17 7 16.33 7 15.5V11.5C7 10.67 6.33 10 5.5 10C4.67 10 4 10.67 4 11.5ZM10 11.5V15.5C10 16.33 10.67 17 11.5 17C12.33 17 13 16.33 13 15.5V11.5C13 10.67 12.33 10 11.5 10C10.67 10 10 10.67 10 11.5ZM3.5 22H19.5C20.33 22 21 21.33 21 20.5C21 19.67 20.33 19 19.5 19H3.5C2.67 19 2 19.67 2 20.5C2 21.33 2.67 22 3.5 22ZM16 11.5V15.5C16 16.33 16.67 17 17.5 17C18.33 17 19 16.33 19 15.5V11.5C19 10.67 18.33 10 17.5 10C16.67 10 16 10.67 16 11.5ZM10.57 1.49001L2.67 5.65001C2.26 5.86001 2 6.29001 2 6.75001C2 7.44001 2.56 8.00001 3.25 8.00001H19.76C20.44 8.00001 21 7.44001 21 6.75001C21 6.29001 20.74 5.86001 20.33 5.65001L12.43 1.49001C11.85 1.18001 11.15 1.18001 10.57 1.49001Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'pensions',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'properties',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'additionalInfo',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'reviewAndSubmit',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V16H3V19C3 20.66 4.34 22 6 22H18C19.66 22 21 20.66 21 19V2L19.5 3.5ZM19 19C19 19.55 18.55 20 18 20C17.45 20 17 19.55 17 19V16H8V5H19V19Z"
          fill={color}
        />
        <path d="M15 7H9V9H15V7Z" fill={color} />
        <path d="M18 7H16V9H18V7Z" fill={color} />
        <path d="M15 10H9V12H15V10Z" fill={color} />
        <path d="M18 10H16V12H18V10Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'calculator',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 2H17C17.5304 2 18.0391 2.21071 18.4142 2.58579C18.7893 2.96086 19 3.46957 19 4V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V4C5 3.46957 5.21071 2.96086 5.58579 2.58579C5.96086 2.21071 6.46957 2 7 2ZM7 4V8H17V4H7ZM7 10V12H9V10H7ZM11 10V12H13V10H11ZM15 10V12H17V10H15ZM7 14V16H9V14H7ZM11 14V16H13V14H11ZM15 14V16H17V14H15ZM7 18V20H9V18H7ZM11 18V20H13V18H11ZM15 18V20H17V18H15Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'checkbox',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.5 21H4.5C4.10252 20.9989 3.72163 20.8405 3.44057 20.5594C3.15951 20.2784 3.00111 19.8975 3 19.5V4.5C3.00111 4.10252 3.15951 3.72163 3.44057 3.44057C3.72163 3.15951 4.10252 3.00111 4.5 3H19.5C19.8975 3.00111 20.2784 3.15951 20.5594 3.44057C20.8405 3.72163 20.9989 4.10252 21 4.5V19.5C20.9989 19.8975 20.8405 20.2784 20.5594 20.5594C20.2784 20.8405 19.8975 20.9989 19.5 21Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconStyled>
    ),
  ],
  [
    'errorOutline',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM12 2C6.47 2 2 6.5 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'progressOutline',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 2.03V4.05C17.39 4.59 20.5 8.58 19.96 12.97C19.5 16.61 16.64 19.5 13 19.93V21.93C18.5 21.38 22.5 16.5 21.95 11C21.5 6.25 17.73 2.5 13 2.03ZM11 2.06C9.05 2.25 7.19 3 5.67 4.26L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06ZM4.26 5.67C3.00966 7.18734 2.24021 9.04308 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67ZM15.5 8.5L10.62 13.38L8.5 11.26L7.44 12.32L10.62 15.5L16.56 9.56L15.5 8.5ZM2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.80693 15.7696 4.24396 14.4226 4.06 13H2.06ZM7.1 18.37L5.67 19.74C7.18478 21.0027 9.03927 21.789 11 22V20C9.5774 19.816 8.23041 19.2531 7.1 18.37Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'successOutline',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'errorMark',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 4H13V15H11V4ZM13 18V20H11V18H13Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'progress',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 2.03V4.05C17.39 4.59 20.5 8.58 19.96 12.97C19.5 16.61 16.64 19.5 13 19.93V21.93C18.5 21.38 22.5 16.5 21.95 11C21.5 6.25 17.73 2.5 13 2.03ZM11 2.06C9.05 2.25 7.19 3 5.67 4.26L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06ZM4.26 5.67C3.00966 7.18734 2.24021 9.04308 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67ZM2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.80693 15.7696 4.24396 14.4226 4.06 13H2.06ZM7.1 18.37L5.67 19.74C7.18478 21.0027 9.03927 21.789 11 22V20C9.5774 19.816 8.23041 19.2531 7.1 18.37Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'twitter',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.533 7.11166C21.5482 7.32485 21.5482 7.53808 21.5482 7.75127C21.5482 14.2538 16.599 21.7462 7.5533 21.7462C4.76648 21.7462 2.17767 20.939 0 19.5381C0.395953 19.5837 0.776625 19.599 1.18781 19.599C3.48727 19.599 5.60405 18.8223 7.29441 17.4975C5.13197 17.4518 3.31978 16.0355 2.69541 14.0863C3 14.1319 3.30455 14.1624 3.62437 14.1624C4.06598 14.1624 4.50764 14.1015 4.91878 13.9949C2.66498 13.538 0.974578 11.5584 0.974578 9.1675V9.10661C1.62937 9.4721 2.39086 9.70052 3.19791 9.73094C1.87303 8.84767 1.00505 7.34008 1.00505 5.63449C1.00505 4.7208 1.24866 3.88324 1.67508 3.15227C4.09641 6.13703 7.73602 8.08624 11.8172 8.29947C11.7411 7.93399 11.6954 7.55332 11.6954 7.1726C11.6954 4.46191 13.8883 2.25381 16.6141 2.25381C18.0304 2.25381 19.3095 2.84772 20.208 3.80711C21.3197 3.59392 22.3857 3.18274 23.3299 2.6193C22.9643 3.76146 22.1877 4.72085 21.1674 5.32994C22.1573 5.22339 23.1167 4.94922 23.9999 4.56855C23.33 5.54313 22.4924 6.41111 21.533 7.11166Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'linkedin',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.70062 22H2.34688V7.97968H6.70062V22ZM4.52141 6.06718C3.12922 6.06718 2 4.91406 2 3.52187C2 2.85315 2.26565 2.21183 2.7385 1.73897C3.21136 1.26611 3.85269 1.00047 4.52141 1.00047C5.19012 1.00047 5.83145 1.26611 6.30431 1.73897C6.77716 2.21183 7.04281 2.85315 7.04281 3.52187C7.04281 4.91406 5.91313 6.06718 4.52141 6.06718ZM22.9953 22H18.6509V15.175C18.6509 13.5484 18.6181 11.4625 16.3873 11.4625C14.1237 11.4625 13.7769 13.2297 13.7769 15.0578V22H9.42781V7.97968H13.6034V9.89218H13.6644C14.2456 8.79062 15.6655 7.62812 17.7838 7.62812C22.19 7.62812 23 10.5297 23 14.2984V22H22.9953Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'delete',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4ZM6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V7H6V19Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'propertyAdded',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="var(--color-smoke-50)" />
        <path
          d="M9 16.2L5.5 12.7C5.11 12.31 4.49 12.31 4.1 12.7C3.71 13.09 3.71 13.71 4.1 14.1L8.29 18.29C8.68 18.68 9.31 18.68 9.7 18.29L20.3 7.7C20.69 7.31 20.69 6.69 20.3 6.3C19.91 5.91 19.29 5.91 18.9 6.3L9 16.2Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'search',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" width="18" height="18">
        <defs />
        <path
          fill={color}
          d="M12.5 11h-.79l-.28-.27A6.471 6.471 0 0013 6.5 6.5 6.5 0 106.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11z"
        />
        <path
          fill={color}
          d="M12.5 11h-.79l-.28-.27A6.471 6.471 0 0013 6.5 6.5 6.5 0 106.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11z"
        />
      </IconStyled>
    ),
  ],
]);

const Icon: React.FC<ComponentProps> = ({ type, color = 'var(--color-plum)' }) => {
  const iconGetter = map.get(type);
  return <>{iconGetter ? iconGetter(color) : ''}</>;
};

export default Icon;
